import {Injectable} from '@angular/core';
import {Question} from '../classes/dynamic-form';
import {FormGroup} from '@angular/forms';
import {map, Observable} from 'rxjs';
import {QuestionService} from './question.service';


@Injectable({ providedIn: "root" } )
export class DynamicFormService {


	questionMap = new Map<string, Question>();
	questionTree: Question[] = [];
	formGroup = new FormGroup({});

	readonly CTRL_PREFIX = "question_";


	constructor(
		private questionService: QuestionService
	) {}


	initialiseForm( formGroup: FormGroup, categorieId: string, answers = "" ): Observable<Question[]> {

		this.questionMap = new Map<string, Question>();
		this.questionTree = [];
		this.formGroup = formGroup;

		return this.questionService.getQuestionsOfCategory( categorieId ).pipe(

			map( questions => {

				console.log( "QUESTIONS", questions )
				if( !questions || !questions.length ) return [];


				for( const question of questions ) {

					if( this.questionMap.has( question.id ) ) {
						console.warn( "!!! this question id already exists !!! not unique ?!", question.id );
					}
					else {
						this.questionMap.set( question.id, question );
					}

					if( !question.parentId ) {
						this.questionTree.push( question );
					}

				}

				for( const question of this.questionTree ) {

					this.findAndAttachChildren( question, questions );

				}

				/*
				for( const backendBranch of EXAMPLE_TREE_BACKEND ) {

					const questionBranch = this.convertQuestionBackendToFrontendAndInit( backendBranch );
					this.questionTree.push( questionBranch );

				}
				*/

				if( answers ) {

					let oSave: any = null;
					try {
						// oSave = JSON.parse( EXAMPLE_SAVE_STR );
						oSave = JSON.parse( answers );
					}
					catch(e) {
						window.alert( "invalid json string" );
						return [];
					}
					// oSave = EXAMPLE_SAVE_OBJ;

					for( const key in oSave ) {

						if( !oSave.hasOwnProperty(key) ) continue;

						if( !key.startsWith( this.CTRL_PREFIX ) ) {
							console.log( "invalid id format", key );
							continue;
						}

						const qId = key.substring( "question_".length );

						// this.formGroup.patchValue( { [key]: oSave[key] } );
						const q = this.questionMap.get( qId );
						if( !q ) {
							console.log( "!!!! question id not found while loading values", key );
							continue;
						}

						q.value = oSave[key];

						if( q.bIsLoop ) this.manageLoopQuestion( q, +oSave[key] );

					}

					for( const [ qId, q ] of this.questionMap.entries() ) {
						q.bIsDisabled = true;
					}

				}

				return this.questionTree;

			})
		);

	}

	private findAndAttachChildren( question: Question, questions: Question[] ) {

		for( const q of questions ) {
			if( q.id == question.id ) continue;
			if( q.parentId == question.id ) {
				question.children.push( q );
				this.findAndAttachChildren( q, questions );
			}
		}

	}




	manageExcludedQuestion( q: Question ) {

		const qExcluded = this.questionMap.get( q.excludesQuestionId );
		if( !qExcluded ) {
			console.log( "!!! excluded question not found", q.id, q.excludesQuestionId );
			return;
		}

		const ctrlExcluded = this.formGroup.get( "question_" + qExcluded.id );
		if( !ctrlExcluded ) {
			console.log( "!!! ctrl excluded not found?!", qExcluded );
			return;
		}

		const ctrl = this.formGroup.get( this.CTRL_PREFIX + q.id );
		if( !ctrl ) {
			console.log( "ctrl not found", this.CTRL_PREFIX + q.id );
			return;
		}

		if( ctrl.value ) {

			qExcluded.bIsDisabled = true;
			this.hideKids( qExcluded );

			// setTimeout to avoid NG0100
			setTimeout( () => {

				ctrlExcluded.disable( { emitEvent: false } );

				if( q.required && qExcluded.required ) {

					if( ctrl.getError( "excludedNotSet" ) ) {
						const errors = { ...ctrl.errors };
						delete errors[ 'excludedNotSet' ];
						ctrl.setErrors( errors, { emitEvent: false } );
					}
					if( ctrlExcluded.getError( "excludedNotSet" ) ) {
						const errors = { ...ctrlExcluded.errors };
						delete errors[ 'excludedNotSet' ];
						ctrlExcluded.setErrors( errors, { emitEvent: false } );
					}

				}

			});

		}
		else {

			qExcluded.bIsDisabled = false;
			ctrlExcluded.enable( { emitEvent: false } );

			if( q.required && qExcluded.required ) {

				if( !ctrlExcluded.value ) {
					ctrl.setErrors( { excludedNotSet: true }, { emitEvent: false } );
				}

			}

		}

	}

	private hideKids( question: Question ) {

		for( const child of question.children ) {
			child.bIsVisible = false;
			this.recursiveHide( child );
		}

	}

	private recursiveHide( question: Question ) {

		question.bIsVisible = false;
		for( const child of question.children ) {
			this.recursiveHide( child );
		}

	}

	manageLoopQuestion( question: Question, value: number ) {

		if( !question.bIsLoop ) return;

		/*
		const ctrl = this.formGroup.get( this.CTRL_PREFIX + question.id );
		if( !ctrl ) {
			console.log( "ctrl not found", this.CTRL_PREFIX + question.id );
			return;
		}

		const nVal = +ctrl.value;
		*/
		const nVal = +value;
		const n = ( isNaN(nVal) || nVal < 0 ) ? 0 : nVal;


		// removal of unwanted questions but never the firsts

		const unwantedQuestions = question.children.filter( q => ( q.nInLoop > n ) && ( q.nInLoop != 1 ) );
		for( const q of unwantedQuestions ) this.questionMap.delete( q.id );

		question.children = question.children.filter( q => ( q.nInLoop <= n ) || ( q.nInLoop == 1 ) );


		if( n > 1 ) {

			const originalQuestions = question.children.filter( q => q.nInLoop == 1 );

			// creation of neeeded questions
			for( let i = 2; i <= n; i++ ) {

				for( const originalQuestion of originalQuestions ) {

					const qiId = originalQuestion.id + "_" + i;
					if( question.children.find( q => q.id == qiId ) ) continue;

					const q = structuredClone( originalQuestion );
					q.id = qiId;
					q.nInLoop = i;
					q.value = null;

					question.children.push( q );

					this.questionMap.set( qiId, q );

				}
			}

		}
		else if( !n ) {
			this.hideKids( question );
		}

	}


}
